import React, { useEffect } from "react";
import { View, Card, Text } from "react-native-ui-lib";

export const batchNumberfields = (response, view = false, moduleName = null, OpenModalCustom, value, isEdit, globalData, setGlobalData) => {
    const formFields = [
        {
            label: 'Batch Number',
            key: 'batch_number',
            type: 'text',
            placeholder: 'Enter batch number',
            visible: true,
            width: '25%',
        },
        {
            label: 'Item',
            key: 'item_id',
            type: 'select',
            placeholder: 'Select the item',
            visible: true,
            width: '25%',
            options: response.items || [],
        },
        {
            label: 'Location',
            key: 'location_id',
            type: 'select',
            placeholder: 'Select the location',
            visible: true,
            width: '25%',
            options: response.locations || [],
        },
        {
            label: 'Expiry Date',
            key: 'expiry_date',
            type: 'date',
            placeholder: 'Enter the expiry date',
            visible: true,
            width: '25%',
        },
        {
            label: 'Quantity',
            key: 'quantity',
            type: 'number',
            placeholder: 'Enter the quantity',
            visible: true,
            width: '25%',
        },
        {
            label: 'Rate',
            key: 'rate',
            type: 'number',
            placeholder: 'Enter the rate',
            visible: true,
            width: '25%',
        },
        {
            label: 'Active',
            key: 'active',
            type: 'checkbox',
            placeholder: 'Select the active status',
            visible: true,
            width: '25%',
        },
        {
            label: 'Is Opening',
            key: 'isOpening',
            type: 'checkbox',
            placeholder: 'Select the opening status',
            visible: true,
            width: '25%',
        },
    ];

    const CustomFields = response.CustomFields;

    if (CustomFields && CustomFields.length > 0) {
        CustomFields.forEach((field) => {
            formFields.push({
                label: field.name,
                key: 'cf.' + field.key,
                type: field.type,
                placeholder: field.placeholder,
                visible: true,
                width: '25%',
                viewField: true,
            });
        });
    }

    return formFields;
}

export const batchNumberMobileCard = (item, index, getFieldValue) => {
    return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
        <View>
            <Text>TEST</Text>
            <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
        </View>
    </Card>;
}

export const batchNumberMain = {
    fields: batchNumberfields,
    mobileCard: null
}